import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useState } from 'react'
import { ThemeContext } from '../../routing/ApplicationRouting.jsx'

export default function Passwordicon({passowrdvisible}) {
  const theme = useContext(ThemeContext);
  const [visible,setvisivle] = useState(false)
  return (
<span className="input-group-text text-white" style={{background: theme.color.companyColor}}><FontAwesomeIcon icon={visible ? faEyeSlash : faEye} style={{cursor: 'pointer'}} onClick={()=>{
    setvisivle(!visible);
    passowrdvisible();
}}/></span>
)
}
